module.exports = __webpack_public_path__ + "img/Void Cheque.0d4b73ad.svg";